module.exports = __webpack_public_path__ + "media/images/riders/VERONIKA_WIDMANN-d9d95779a7f61f544a138b0c07caabc6.png";